import React from "react";
import Loading from "./Loading";

const Table = ({ column, data, loader }) => {
  // console.log("---------------------")
  return (
    <>
      <table className="table">
        <thead style={{ background: "#FFF6F6" }}>
          <tr className="border rounded">
            {column?.map((col, ind) => {
              if (col.labelComponent) {
                return (
                  <th className="border-0 bg-transparent " key={ind}>
                    {col.labelComponent(col, data)}
                  </th>
                );
              }
              return (
                <th className="border-0 bg-transparent " key={ind}>
                  {col.label}
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {data?.length > 0 &&
            !loader &&
            data?.map((item, key) => (
              <tr key={key}>
                {column.map((col, ind) => {
                  if (col.isComponent) {
                    return (
                      <td className="" key={ind}>
                        {col.component(item, key, data)}
                      </td>
                    );
                  }

                  return (
                    <td className="" key={ind}>
                      {/* <p className={`${col.classNames} m-0`}>{item[col.id]}</p> */}
                      <p className={`${col.classNames} m-0`}>
                        {col.id === "email"
                          ? item[col.id]
                          : typeof item[col.id] === "string"
                          ? item[col.id]?.charAt(0)?.toUpperCase() +
                            item[col.id]?.slice(1)
                          : item[col.id]}
                      </p>
                    </td>
                  );
                })}
              </tr>
            ))}

          {data?.length <= 0 && !!!loader && (
            <tr>
              <td colSpan={column.length}>
                <p className="text-center">No Data Found!</p>
              </td>
            </tr>
          )}

          {!!loader && (
            <tr>
              <td colSpan={column.length} align="center">
                <Loading />
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </>
  );
};

export default Table;
